import { SCREENTABS_VALIDATION_ERROR } from './constants';
export var toScreenTabsValidationError = function toScreenTabsValidationError(message) {
  return {
    message: message,
    type: SCREENTABS_VALIDATION_ERROR
  };
};